import { makeStyles } from '@material-ui/core/styles'
export const scarletWellWidgetStyles = makeStyles((theme) => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: 478,
    overflowY: 'clip',
    margin: 0,
    width: 335,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginTop: 5,
    marginBottom: 5,
  },
  searchBar: {
    width: '70%',
    marginTop: 5,
    marginBottom: 5,
  },
  searchBarButton: {
    cursor: 'pointer',
    '&:hover': {
      border: `2px solid ${theme.palette.base.lightGray}`,
    },
  },
  tabBackground: {
    overflowY: 'hidden',
    width: '100%',
    minHeight: 35,
    height: '35px',
  },
  modalTabs: {
    width: 335,
    height: 35,
    minHeight: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabTextLabel: {
    marginRight: 10,
  },
  text: {
    color: theme.palette.primary.headerText,
    margin: 10,
  },
  // check-in tab
  checkinRoot: {
    padding: '6px',
  },
  mainImage: {
    width: '100%',
    height: '260px',
    objectFit: 'cover',
    borderRadius: '5px',
    marginBottom: '6px',
    marginTop: '6px',
  },
  checkInCard: {
    height: '145px',
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // color: theme.palette.base.red,
  },
  checkinText: {
    marginLeft: '4px',
  },
}))

export default scarletWellWidgetStyles
